<script>
  import { createEventDispatcher } from 'svelte';
  import { ComboBox, FormGroup } from 'carbon-components-svelte';

  export let required = false,
    disabled = false,
    labelText = '',
    invalid = false,
    invalidText,
    name = '',
    items = [],
    placeholder = '',
    helperText = '',
    /** @type {string | null} */
    selectedId = null;

  const dispatch = createEventDispatcher();
  let touched = false;

  function shouldFilterItem(item, value) {
    if (!value) {
      return true;
    }

    const searchValue = value.toLowerCase();
    return item.text.toLowerCase().includes(searchValue);
  }

  function onChange(event) {
    // bug: ignore empty event fired by ComboBox on mount
    if (event?.type === 'select' && !event?.detail?.selectedId) {
      return;
    }

    const selectedId = event?.detail?.selectedId ?? null;
    const item = selectedId ? items.find((row) => row.id === selectedId)?.value : null;
    dispatch('change', { selectedId, item });
    // bug: if there is a selected value on mount, it is not displayed; updating the touched variable forces a re-render of the component and fixes the issue
    if (!touched) {
      touched = true;
    }
  }

  // bug: same as above; touch component to force re-render if there were no items on mount
  $: computedSelectedId = items.length ? selectedId : null;
</script>

<div class="bx--form-item combo-box-wrapper">
  <FormGroup legendText={labelText} {required}>
    {#key touched}
      <ComboBox
        {invalid}
        {invalidText}
        {name}
        {shouldFilterItem}
        {disabled}
        {items}
        {placeholder}
        selectedId={computedSelectedId}
        {helperText}
        on:clear={onChange}
        on:select={onChange}
        let:item
      >
        <div>
          <strong><slot {item} /></strong>
        </div>
        <div class="item-details">
          <slot name="item-details" />
        </div>
      </ComboBox>
    {/key}
  </FormGroup>
</div>

<style>
  .item-details {
    font-size: 0.75rem;
    color: var(--cds-text-helper);
  }

  .combo-box-wrapper :global(.bx--fieldset) {
    width: 100%;
    margin-bottom: 0;
  }

  .combo-box-wrapper :global(.bx--list-box__wrapper) {
    margin-top: 0 !important;
  }
</style>
